export enum SupportDetails {
    ZAPPING = 'Zapping',
    TICKET = 'Viagem CA/ML',
    LOAD_AUTHORIZATION = 'Autorizações de Carregamento',
    FAMILY_TICKET = 'Passe Família',
    OTHERS = 'Outros Títulos '
}
